var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-preview-page"},[_c('iframe',{staticClass:"preview-box",attrs:{"src":_vm.previewUrl,"frameborder":"0"},on:{"load":_vm.hideLoading}})])
}
var staticRenderFns = []

export { render, staticRenderFns }